<template>
  <q-card :style="!$q.screen.lt.md?'width: 500px; max-width: 80vw;':''">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>ثبت فعالیت برای </span>{{ commentInfo.UserName }}
        <template v-slot:action>
          <q-btn icon="close" round flat padding="none" v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-form @submit="creatTask">
      <q-card-section v-if="$store.state.roles.some(v=>['admin','can_define_task_from_comment'].includes(v))">
        <q-select
            v-model="organizeUnit"
            label="واحد سازمانی"
            :options="$store.state.organizeUnit"
            option-value="Id"
            option-label="title"
            :rules="[requireRole]"
        />
        <q-input dir="ltr" filled v-model="taskDate" mask="date" :rules="['date']"
                 label="تاریخ یادآوری" clearable readonly>
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                <q-date v-model="taskDate" calendar="persian">
                  <div class="row items-center justify-center">
                    <q-btn v-close-popup label="تایید" color="primary" flat/>
                    <q-btn v-close-popup @click="taskDate = ToJalaliDate(new Date())" label="امروز"
                           color="primary"
                           flat/>
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
        <q-input filled v-model="taskTime"  type="time"
                 label="زمان یادآوری" clearable step="2"/>
      </q-card-section>
      <q-card-actions align="center">
        <q-btn label="تایید" icon="search" type="submit" color="primary"/>
        <q-btn label="انصراف" v-close-popup
               type="reset" icon="search_off" color="red" flat class="q-ml-sm"/>
      </q-card-actions>
    </q-form>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "CreateTask",
  props: {
    commentInfo: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      organizeUnit: undefined,
      taskDate: undefined,
      taskTime: undefined
    }
  },
  methods: {
    ...mapActions({
      sendTaskData: 'Customers/createTask'
    }),
    requireRole(val) {
      if (val === null || val === undefined || val === '') {
        return 'انتخاب الزامی است'
      }
    },
    creatTask() {
      if (this.organizeUnit !== undefined) {
        const data = `${this.commentInfo.Auth}#${this.organizeUnit.name}#${this.$store.state.visitLogTypeList.filter(item => item.title === this.commentInfo.LogType)[0].name}#${this.commentInfo.VisitComment}#${this.ToGregorianDateTime(this.taskDate)}#${this.taskTime}#${this.commentInfo.Cs_Name}`
        this.sendTaskData({data}).then((res) => {
          if (res === 'OK') {
            this.$q.notify({
              message: 'فعالیت ثبت گردید',
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
            this.$emit('close-dialog')
          }
        })
      }
    }
  },
  computed: {},
  watch: {},
  created() {

  }
}
</script>

<style scoped>

</style>